import TheftsService from "@/api/Thefts";
import {
  addMarkerSelector,
  isMenuOpenAtom,
  mapRefAtom,
  selectedTimeAtom,
  userLocationMarkerAtom,
} from "@/api/atoms";
import { lastReported } from "@/config";
import { UilUserLocation } from "@iconscout/react-unicons";
import { useAtomValue, useSetAtom } from "jotai";
import { useState } from "react";

import { Toggle } from "./Toggle";

export type Coordinates = {
  latitude: number;
  longitude: number;
};
interface GeolocateProps {
  onGeolocate: (coords: Coordinates) => void;
}

export function GeolocateControl(props: GeolocateProps) {
  const mapRef = useAtomValue(mapRefAtom);
  const [allowed, setAllowed] = useState(true);
  const [localized, setLocalized] = useState(false);

  const selectedTime = useAtomValue(selectedTimeAtom);

  const _addMarker = useSetAtom(addMarkerSelector);
  const setUserMarker = useSetAtom(userLocationMarkerAtom);
  const setIsMenuOpen = useSetAtom(isMenuOpenAtom);

  const handleGeolocation = async (coords: Coordinates) => {
    if (!localized) {
      setLocalized(true);
      props.onGeolocate(coords);
      mapRef?.flyTo({
        center: {
          lat: coords.latitude,
          lng: coords.longitude,
        },
        zoom: 14,
      });

      try {
        const { yearCounts, lastReportedMonthCount } = await TheftsService.getTheftsInRadius({
          lat: coords.latitude,
          lng: coords.longitude,
          start: lastReported[selectedTime].start,
          end: lastReported[selectedTime].end,
        });

        setUserMarker({
          latitude: coords.latitude,
          longitude: coords.longitude,
          counts: {
            yearCounts,
            lastReportedMonthCount,
          },
        });
      } catch (err) {
        console.error(err);
      }
    }
  };

  const handleToggle = () => {
    setLocalized(false);
    navigator.geolocation.getCurrentPosition(
      (res) => {
        setIsMenuOpen(false);
        handleGeolocation(res.coords);
      },
      () => setAllowed(false),
    );
  };

  return (
    <Toggle onClick={handleToggle} forceActive={!allowed}>
      <UilUserLocation />
      {!allowed && (
        <div className="absolute left-0 top-1/2 z-10 h-0.5 w-full rotate-45 bg-gray-200" />
      )}
    </Toggle>
  );
}
